import { isColorDark } from '@ihs-widget/stores/ColorContext';
import React from 'react';

interface DynamicShieldProps {
  color?: string;
}

const DynamicShield: React.FC<DynamicShieldProps> = ({
  color = "#0A6638",
}) => {
  const shouldAddBorder = isColorDark(color);
  const strokeAttribute = shouldAddBorder ? 'stroke="white" stroke-width="0.5"' : 'stroke="#000000" stroke-width="0.5"';
  
  const svgContent = `<svg width="21" height="24" viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M9.29583 0.527792C7.31151 2.91694 4.22433 4.58841 1.50175 4.49762C0.742086 4.47229 -0.00891586 5.02354 8.00177e-05 5.78988C0.0680674 11.5815 0.861269 20.3438 10.1155 23.929C10.3599 24.0237 10.6401 24.0237 10.8845 23.929C20.1387 20.3438 20.9319 11.5815 20.9999 5.78988C21.0089 5.02354 20.2579 4.47229 19.4982 4.49762C16.7757 4.58841 13.6885 2.91694 11.7042 0.527792C11.1197 -0.175931 9.88031 -0.175931 9.29583 0.527792ZM14.3008 4.59502C13.9391 4.39323 13.4822 4.52289 13.2804 4.88463C13.0787 5.24636 13.2083 5.70319 13.57 5.90498C14.9338 6.66572 16.4276 7.2071 17.9555 7.41141C17.843 9.93447 17.4918 12.5543 16.4685 14.8861C16.3021 15.2654 16.4746 15.7078 16.8539 15.8743C17.2332 16.0407 17.6756 15.8682 17.8421 15.4889C19.0249 12.7934 19.37 9.81775 19.4683 7.1241C19.491 6.50425 19.0164 6.0161 18.4439 5.95857C17.0355 5.81705 15.6173 5.32939 14.3008 4.59502Z" fill="${color}" ${strokeAttribute}/>
</svg>`;

  return (
    <div className='flex justify-center items-center w-[24px] h-[24px]'>
      <div 
      className=''
      dangerouslySetInnerHTML={{ __html: svgContent }}
      style={{ 
        display: 'inline-block'
      }}
    />
    </div>
  );
};

export default DynamicShield; 